import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import BranchSettingsForm from './BranchSettingsForm'
import { Branch, UpdateBranchInput } from '@/queries/useBranches'
import { useTranslation } from 'react-i18next'

interface BranchSettingsDialogProps {
  branch: Branch
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (data: UpdateBranchInput) => void | Promise<void>
  isLoading?: boolean
  error?: Error | null
}

export default function BranchSettingsDialog({
  branch,
  open,
  onOpenChange,
  onSubmit,
  isLoading = false,
  error,
}: BranchSettingsDialogProps) {
  const { t } = useTranslation('admin')
  
  const handleSubmit = async (data: UpdateBranchInput) => {
    await onSubmit(data)
    onOpenChange(false)
  }

  const handleCancel = () => {
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[600px]"
        data-testid="branch-settings-dialog"
      >
        <DialogHeader>
          <DialogTitle data-testid="branch-settings-dialog-title">
            {t('branches.dialog.settingsTitle')}
          </DialogTitle>
          <DialogDescription data-testid="branch-settings-dialog-description">
            {t('branches.dialog.settingsDescription', { name: branch.name })}
          </DialogDescription>
        </DialogHeader>

        <BranchSettingsForm
          branch={branch}
          onSubmit={handleSubmit}
          isLoading={isLoading}
          error={error}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  )
}

